<div
  class="archived"
  *ngIf="hasActiveTicketRooms && !showActiveTickets && !showArchived"
  (click)="showActiveTicketsRooms()"
>
  <div class="archived-icon-text">
    <div class="archived-icon">
      <mat-icon class="material-icon-outlined">priority_high</mat-icon>
    </div>
    <div class="archived-text">Atendimentos Ativos</div>
  </div>
  <div class="archived-num-unread" *ngIf="numActiveTicketsRooms > 0">
    <span>{{ numActiveTicketsRooms }}</span>
  </div>
</div>
